document.addEventListener("DOMContentLoaded", function(){

var AA_LANG = (window.location.pathname.split('/').filter(function(p){ return p.length > 0; })[0] || 'es').toLowerCase();
var knownLocales = ['ar','fr','en','pt','pt-pt','ca','el','it','tr'];
if(knownLocales.indexOf(AA_LANG) === -1) AA_LANG = 'es';

var TXT = {
  fr: { label:"Test\u00e9 et certifi\u00e9 par des laboratoires ind\u00e9pendants", biodeg:"91% Biodegradable", micro:"Sans microplastiques", reach:"Conforme REACH", toxico:"Toxicit\u00e9 aquatique", metales:"Sans m\u00e9taux lourds", fds:"FDS/SDS conforme", clp:"Non classifi\u00e9 dangereux" },
  en: { label:"Tested and certified by independent laboratories", biodeg:"91% Biodegradable", micro:"No microplastics", reach:"REACH Compliant", toxico:"Aquatic toxicity", metales:"No heavy metals", fds:"SDS compliant", clp:"Not classified hazardous" },
  pt: { label:"Testado e certificado por laborat\u00f3rios independentes", biodeg:"91% Biodegrad\u00e1vel", micro:"Sem micropl\u00e1sticos", reach:"Conforme REACH", toxico:"Toxicidade aqu\u00e1tica", metales:"Sem metais pesados", fds:"FDS/SDS conforme", clp:"N\u00e3o classificado perigoso" },
  ar: { label:"\u062a\u0645 \u0627\u062e\u062a\u0628\u0627\u0631\u0647 \u0648\u0627\u0639\u062a\u0645\u0627\u062f\u0647 \u0645\u0646 \u0645\u062e\u062a\u0628\u0631\u0627\u062a \u0645\u0633\u062a\u0642\u0644\u0629", biodeg:"91% \u0642\u0627\u0628\u0644 \u0644\u0644\u062a\u062d\u0644\u0644 \u0627\u0644\u062d\u064a\u0648\u064a", micro:"\u062e\u0627\u0644\u064a \u0645\u0646 \u0627\u0644\u0645\u064a\u0643\u0631\u0648\u0628\u0644\u0627\u0633\u062a\u064a\u0643", reach:"\u0645\u0637\u0627\u0628\u0642 REACH", toxico:"\u0633\u0645\u064a\u0629 \u0645\u0627\u0626\u064a\u0629", metales:"\u062e\u0627\u0644\u064a \u0645\u0646 \u0627\u0644\u0645\u0639\u0627\u062f\u0646 \u0627\u0644\u062b\u0642\u064a\u0644\u0629", fds:"\u0628\u064a\u0627\u0646 \u0627\u0644\u0633\u0644\u0627\u0645\u0629 \u0645\u0637\u0627\u0628\u0642", clp:"\u063a\u064a\u0631 \u0645\u0635\u0646\u0641 \u062e\u0637\u0631\u0627" },
  ca: { label:"Provat i certificat per laboratoris independents", biodeg:"91% Biodegradable", micro:"Sense micropl\u00e0stics", reach:"Conforme REACH", toxico:"Toxicitat aqu\u00e0tica", metales:"Sense metalls pesants", fds:"FDS/SDS conforme", clp:"No classificat perills\u00f3s" },
  el: { label:"\u0394\u03bf\u03ba\u03b9\u03bc\u03b1\u03c3\u03bc\u03ad\u03bd\u03bf \u03b1\u03c0\u03cc \u03b1\u03bd\u03b5\u03be\u03ac\u03c1\u03c4\u03b7\u03c4\u03b1 \u03b5\u03c1\u03b3\u03b1\u03c3\u03c4\u03ae\u03c1\u03b9\u03b1", biodeg:"91% \u0392\u03b9\u03bf\u03b4\u03b9\u03b1\u03c3\u03c0\u03ce\u03bc\u03b5\u03bd\u03bf", micro:"\u03a7\u03c9\u03c1\u03af\u03c2 \u03bc\u03b9\u03ba\u03c1\u03bf\u03c0\u03bb\u03b1\u03c3\u03c4\u03b9\u03ba\u03ac", reach:"\u03a3\u03c5\u03bc\u03b2\u03b1\u03c4\u03cc REACH", toxico:"\u03a5\u03b4\u03ac\u03c4\u03b9\u03bd\u03b7 \u03c4\u03bf\u03be\u03b9\u03ba\u03cc\u03c4\u03b7\u03c4\u03b1", metales:"\u03a7\u03c9\u03c1\u03af\u03c2 \u03b2\u03b1\u03c1\u03ad\u03b1 \u03bc\u03ad\u03c4\u03b1\u03bb\u03bb\u03b1", fds:"SDS \u03c3\u03cd\u03bc\u03c6\u03c9\u03bd\u03bf", clp:"\u039c\u03b7 \u03b5\u03c0\u03b9\u03ba\u03af\u03bd\u03b4\u03c5\u03bd\u03bf" },
  it: { label:"Testato e certificato da laboratori indipendenti", biodeg:"91% Biodegradabile", micro:"Senza microplastiche", reach:"Conforme REACH", toxico:"Tossicit\u00e0 acquatica", metales:"Senza metalli pesanti", fds:"SDS conforme", clp:"Non classificato pericoloso" },
  tr: { label:"Ba\u011f\u0131ms\u0131z lab. taraf\u0131ndan sertifikaland\u0131r\u0131lm\u0131\u015f", biodeg:"%91 Biyobozunur", micro:"Mikroplastik i\u00e7ermez", reach:"REACH Uyumlu", toxico:"Su toksisitesi", metales:"A\u011f\u0131r metal i\u00e7ermez", fds:"GBF/SDS uyumlu", clp:"Tehlikeli s\u0131n\u0131f\u0131nda de\u011fil" }
};

var L = TXT[AA_LANG];

// Step 1: translate text only (never touch structure or animation)
if(L){
  var lbl = document.getElementById('aq_cert_label');
  if(lbl) lbl.textContent = L.label;
  var cards = document.querySelectorAll('.aq-c[data-cert]');
  cards.forEach(function(card){
    var key = card.getAttribute('data-cert');
    if(L[key]){ var n = card.querySelector('.aq-n'); if(n) n.textContent = L[key]; }
  });
}

// Step 2: fix animation offset ONLY if text changed width
// We measure the first 8 cards (one set) vs total 16 cards
// and set the translateX to exactly half of scrollWidth
var track = document.querySelector('.aq-tr');
if(track && AA_LANG !== 'es'){
  // Give browser time to reflow after text change
  setTimeout(function(){
    // Count total cards
    var allCards = track.querySelectorAll('.aq-c');
    var total = allCards.length; // should be 16
    if(total < 2) return;

    // Measure width of first half only
    var halfCount = Math.floor(total / 2);
    var halfWidth = 0;
    var gap = 12; // matches CSS gap:12px
    for(var i = 0; i < halfCount; i++){
      halfWidth += allCards[i].offsetWidth + gap;
    }

    // Stop current animation
    track.style.animation = 'none';
    track.style.transform = 'translateX(0)';

    // Force reflow
    void track.offsetWidth;

    // Inject precise keyframe
    var sid = 'aq-fix';
    var ex = document.getElementById(sid);
    if(ex) ex.parentNode.removeChild(ex);
    var s = document.createElement('style');
    s.id = sid;
    s.textContent = '@keyframes aqfix{0%{transform:translateX(0)}100%{transform:translateX(-'+halfWidth+'px)}}';
    document.head.appendChild(s);

    // Restart with precise animation
    track.style.animation = 'aqfix 32s linear infinite';

  }, 200);
}

// RTL for Arabic
if(AA_LANG === 'ar'){
  var wrap = document.querySelector('.aq-wrap');
  if(wrap) wrap.style.direction = 'rtl';
}

});